import {environment} from "../environments/environment";


export function getImageUrl(path: string) {
    return `${environment.s3Path + '/' + path}`
}